/* eslint-disable no-const-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import useRegistrationContext from "../../../../hooks/useRegistrationContext";
import toast, { Toaster } from "react-hot-toast";
import { useQuery } from "react-query";

import PhoneInput from "react-phone-input-2";

const ContactInformation = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const {
		data,
		checkMobileNumberValidity,
		handleMobileNumberInput,
		handleChange,
		validateEmailAddress,
		emailInputRef,
	} = useRegistrationContext();

	const content = (
		<>
			<fieldset className="col-sm-6">
				<div className="form-group row">
					<label
						htmlFor="mobile_number"
						className="col-sm-4 col-form-label"
					>
						Mobile Number <span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<PhoneInput
							id="mobile_number"
							inputStyle={{
								paddingTop: 16,
								paddingRight: 14,
								paddingBottom: 15,
								paddingLeft: 58,
								fontSize: 16,
								width: "100%",
								zIndex: 1,
								height: 40,
								backgroundColor: "#F3F6F9",
							}}
							autoFormat
							countryCodeEditable={false}
							country={"gh"}
							enableSearch={true}
							enableClickOutside={false}
							disableDropdown={false}
							value={data.contactMobileNumber}
							inputProps={{
								name: "contactMobileNumber",
								required: true,
								autoFocus: true,
							}}
							onChange={(value, countryObj, e, formattedValue) =>
								handleMobileNumberInput(
									value,
									countryObj,
									e,
									formattedValue
								)
							}
							onBlur={(e, countryData) =>
								checkMobileNumberValidity(e, countryData)
							}
						/>
					</div>
				</div>
				<div className="form-group row">
					<label htmlFor="email" className="col-sm-4 col-form-label">
						Email Address<span>&nbsp;&nbsp;</span>
					</label>
					<div className="col-sm-8">
						<input
							ref={emailInputRef}
							type="email"
							id="email"
							autoComplete="off"
							onBlur={validateEmailAddress}
							onChange={handleChange}
							style={{
								textTransform: "lowercase",
							}}
							value={data.contactEmail}
							name="contactEmail"
							className="form-control"
						/>
					</div>
				</div>
			</fieldset>
		</>
	);

	<Toaster toastOptions={{ position: "top-center" }} />;
	return content;
};
export default ContactInformation;
